import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { createQueryClient } from './utils/queryClient';
import { initTelemetry } from './features/observability/telemetry';
import './index.css';
import './styles/admin.css';
import './styles/aiUsage.css';
import './features/logins/components/logins.css';
import './features/agent_runs/components/agentRuns.css';

initTelemetry();

const queryClient = createQueryClient();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);
